import { IFormFieldType } from '@/widgets/create-widget'

const StickyEnrollBarSchema: { [key: string]: IFormFieldType } = {
  bottomStickyBar: {
    type: 'Object',
    label: 'Bottom Sticky Bar',
    required: false,
    children: {
      heading: {
        type: 'String',
        label: 'Heading',
        required: false,
      },
      subHeading: {
        type: 'String',
        label: 'Sub-heading',
        required: false,
      },
      buttonText: {
        type: 'String',
        label: 'Button Text',
        required: false,
      },
      minHeight: {
        type: 'Number',
        label: 'Minimum Height',
        required: false,
      },
      maxHeight: {
        type: 'Number',
        label: 'Maximum Height',
        required: false,
      },
    },
  },
}

export default StickyEnrollBarSchema

export type StickyEnrollBarProps = {
  bottomStickyBar: {
    heading: string
    subHeading: string
    buttonText: string
    minHeight: number
    maxHeight: number
  }
}

export const StickyEnrollBarDefaultValues: StickyEnrollBarProps = {
  bottomStickyBar: {
    heading: 'Learning made fun for Curious Minds! 🚀 ',
    subHeading: 'Choose a learning program for your kid to get started.',
    buttonText: 'Book a Demo',
    minHeight: 0,
    maxHeight: 0,
  },
}
